import ConfettiExplosion from "react-confetti-explosion";
import styles from "./Confetti.module.css";

export function Confetti() {
  const windowWidth = window.innerWidth;
  const position = 0.85 * windowWidth;

  return (
    <div>
      <div style={{ position: "absolute", top: "50%", left: `${position}px` }}>
        <ConfettiExplosion
          particleCount={100}
          zIndex={2003}
          force={1}
          duration={5000}
          colors={[
            "#f4603e",
            "#ffeceb",
            "#8e8ece",
            "#1e1870",
            "#d0f1e1",
            "#41c588",
          ]}
        />
      </div>
      <div className={styles.duneLogo} />
      <div className={styles.duneLogo} />
    </div>
  );
}
